import { Action } from 'store/store';
import { WidgetActionPayload } from 'widgets/store/actions';

export enum BlotterFilteredOrdersActionType {
    INCREMENT_RESULTS_TICK = 'BLOTTER_FILTERED_ORDERS_INCREMENT_RESULTS_TICK',
}

export type BlotterFilteredOrderIncrementResultsTickAction = Action<
    BlotterFilteredOrdersActionType.INCREMENT_RESULTS_TICK,
    WidgetActionPayload
>;

export const incrementResultsTick = (widgetKey: string) => ({
    type: BlotterFilteredOrdersActionType.INCREMENT_RESULTS_TICK,
    payload: { widgetKey },
});

export type BlotterFilteredOrdersAction =
    BlotterFilteredOrderIncrementResultsTickAction;
